<template>
    <div class="card">
        <div class="card__title">
            <h5></h5>
            <div class="card__controls">
                <div class="form-field">
                    <input-field
                        v-model="searchVentas"
                        :id="'busqueda_ventas' + tipoVenta"
                        placeholder="Realice una búsqueda..."
                    ></input-field>
                </div>
            </div>
        </div>
        <div class="card__content">
            <div class="table-responsive">
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th>Venta</th>
                            <th>Cliente</th>
                            <th>Fecha</th>
                            <th>Valor total</th>
                            <th>Comisión</th>
                            <th v-show="tipoVenta === 'I' || tipoVenta === 'R'">Pago</th>
                            <th>
                            <button
                                @click="agregarVentas"
                                tooltip="Agregar venta"
                                class="btn-success"
                            >
                                <i class="fa fa-plus"></i>
                            </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="coincideVentas(venta)" v-for="(venta, index) in ventas" :key="venta.id">
                            <td>
                            {{ venta.numero_documento }}
                            </td>
                            <td>
                            {{ venta.nombre_cliente }}
                            </td>
                            <td>
                            {{ venta.fecha }}
                            </td>
                            <td>
                            {{ moneyFormat(venta.valor_total) }}
                            </td>
                            <td>
                                {{ moneyFormat(venta.valor_comision) }}
                            </td>
                            <td v-show="tipoVenta === 'I' || tipoVenta === 'R'">
                                {{ moneyFormat(venta.valor_pago) }}
                            </td>
                            <td>
                                <button @click="quitarVenta(index)" tooltip="Quitar" class="btn-danger btn--text">
                                    <i class="fa fa-times"></i>
                                </button>
                                <!-- <button @click="mover(index)" tooltip="Mover" class="btn-primary btn--text"><i class="fa fa-share"></i></button> -->
                            </td>
                        </tr>
                        <tr v-show="ventas.length === 0">
                            <td :colspan="tipoVenta === 'I' || tipoVenta === 'R'?7:6">
                                <strong>No se ha agregado ventas.</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <modal
                    :clickToClose="false"
                    :name="'tableSelectVen' + tipoVenta"
                    height="auto"
                    width="70%"
                    scrollable
                    resizable
                    adaptive
                    reset
                    >
                    <k-table-select
                        @visitarLink="visitarLink"
                        v-model="ventas"
                        :columnaSaldo="tipoVenta === 'I'?'saldo_incobrable':'saldo_retorno'"
                        :saldoSeleccionable="tipoVenta === 'I' || tipoVenta === 'R'"
                        :columnas="[
                            {
                                nombre: 'numero_documento',
                                descripcion: 'Número de documento',
                                link: true
                            },
                            {
                                nombre: 'cliente.descripcion_cliente',
                                descripcion: 'Cliente',
                            },
                            {
                                nombre: 'fecha',
                                descripcion: 'Fecha',
                                sortable: true,
                            },
                            {
                                nombre: 'venta_total',
                                descripcion: 'Venta total',
                                sortable: true,
                                money: true
                            },
                            {
                                nombre: 'valor_total',
                                descripcion: 'Valor total',
                                sortable: true,
                            },
                            {
                                nombre: 'total_pagado',
                                descripcion: 'Abonado',
                                money: true,
                                sortable: true,
                            },
                            {
                                nombre: 'valor_comision',
                                descripcion: 'Comisión',
                                money: true,
                                sortable: true,
                            },
                            {
                                nombre: 'saldo_incobrable',
                                descripcion: 'Saldo incobrable',
                                money: true,
                                sortable: true, 
                                hidden: tipoVenta !== 'I'
                            },
                             {
                                nombre: 'saldo_retorno',
                                descripcion: 'Saldo retorno',
                                money: true,
                                sortable: true,
                                hidden: tipoVenta !== 'R'
                            },
                            {
                                nombre: 'valor_pago',
                                descripcion: 'Valor seleccionado',
                                money: true,
                                sortable: true,
                                hidden: tipoVenta !== 'I' && tipoVenta !== 'R'
                            },
                            {
                                nombre: 'valor_devoluciones',
                                descripcion: 'Devoluciones',
                                money: true,
                                sortable: true,
                            },
                            {
                                nombre: 'valor_notas_credito',
                                descripcion: 'Notas de crédito',
                                money: true,
                                sortable: true,
                            },
                        ]"
                        :params="{
                            supervisor_id: supervisor_id,
                            tipoVenta: tipoVenta,
                            liquidacion_id: liquidacion_id
                        }"
                        @cerrar="cerrarVentas"
                        :urlConsulta="url + '/ventas-nomina-supervisor'"
                        title="Seleccione una o varias ventas"
                        ref="kTableSelectVen"
                        @seleccionar="seleccionarVentas"
                    ></k-table-select>
                </modal>
            </div>
        </div>
        <modal :name="'mover' + tipoVenta" height="auto" width="60%">
            <div class="layout">
                <div class="layout__header">
                    <div class="layout__title">
                        <h5>Mover</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <p v-show="tipoVenta !== 'C'">
                            <label for="canceladas_opt">
                                <input v-model="moverA" type="radio" name="mover_a" id="canceladas_opt" value="C"><span>Canceladas</span>
                            </label>
                        </p>
                        <p v-show="tipoVenta !== 'DC'">
                            <label for="devoluciones_completas_opt">
                                <input v-model="moverA" type="radio" name="mover_a" id="devoluciones_completas_opt" value="DC"><span>Devoluciones completas</span>
                            </label>
                        </p>
                        <p v-show="tipoVenta !== 'DP'">
                            <label for="parciales_opt">
                                <input v-model="moverA" type="radio" name="mover_a" id="parciales_opt" value="DP"><span>Devoluciones parciales</span>
                            </label>
                        </p>
                        <p v-show="tipoVenta !== 'R'">
                            <label for="retornos_opt">
                                <input v-model="moverA" type="radio" name="mover_a" id="retornos_opt" value="R"><span>Retornos</span>
                            </label>
                        </p>
                        <p v-show="tipoVenta !== 'I'">
                            <label for="incobrables_opt">
                                <input v-model="moverA" type="radio" name="incobrables" id="incobrables_opt" value="I"><span>Incobrables</span>
                            </label>
                        </p>
                    </div>
                </div>
                <div class="modal-buttons">
                    <button type="button" @click="confirmar" class="btn-success"><i class="fa fa-check"></i><span>Confirmar</span></button>
                    <button type="button" @click="cerrar" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import KTableSelect from '../../general/KTableSelect.vue';
export default {
    components: {
        KTableSelect
    },
    props: {
        liquidacion_id: {
            type: String,
            required: false,
            default: ''
        },
        value: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        supervisor_id: {
            required: false
        },
        tipoVenta: {
            type: String,
            required: true,
            default: ''
        }
    },
    data: function () {
        return {
            ventas: this.value,
            url: url,
            moneyFormat: moneyFormat,
            searchVentas: '',
            moverA: '',
            selectedTarjeta: null
        };
    },
    methods: {
        visitarLink: function (obj) {
            window.open(url + '/logistica/pedidos/' + obj.id + '/edit', '_blank');
        },
        cerrar: function () {
            this.$modal.hide('mover' + this.tipoVenta);
        },
        confirmar: function () {
            this.$emit('mover', this.selectedTarjeta, this.tipoVenta, this.moverA);
            this.$modal.hide('mover' + this.tipoVenta);
        },
        mover: function (index) {
            this.moverA = '';
            this.selectedTarjeta = this.ventas[index];
            this.$modal.show('mover' + this.tipoVenta);
        },
        coincideVentas: function (venta) {
            let busqueda = this.searchVentas.toUpperCase();
            if (busqueda != "") {
                return (
                venta.numero_documento.toUpperCase().includes(busqueda) ||
                venta.nombre_cliente
                    .toUpperCase()
                    .includes(busqueda) ||
                venta.fecha.includes(busqueda) ||
                venta.valor_total.toString().includes(busqueda)
                );
            } else return true;
        },
        quitarVenta: function (index) {
            this.ventas.splice(index, 1);
            this.$emit('input', this.ventas);
        },
        agregarVentas: function () {
            this.$modal.show("tableSelectVen" + this.tipoVenta);
        },
        seleccionarVentas: function (ventas) {
            this.ventas.splice(0, this.ventas.length);
            for (let i = 0; i < ventas.length; i++) {
                this.ventas.push({
                    id: ventas[i].id,
                    numero_documento: ventas[i].numero_documento,
                    valor_total: ventas[i].valor_total,
                    total_abonado: ventas[i].total_pagado,
                    nombre_cliente: ventas[i].cliente.descripcion_cliente,
                    fecha: ventas[i].fecha,
                    valor_comision: ventas[i].valor_comision,
                    valor_pago: ventas[i].valor_pago,
                    saldo_incobrable: ventas[i].saldo_incobrable
                });
            }
            this.$modal.hide("tableSelectVen" + this.tipoVenta);
            this.$emit('input', this.ventas);
        },
        cerrarVentas: function () {
            this.$modal.hide("tableSelectVen" + this.tipoVenta);
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/VentasLiquidacion.vue